// src/utils/handleReset.js
export default function handleReset(
    setWord, setChrIndex, setTime, setMstk, setWPM, setCPM, setAcc, setspScore, setMisPenal, timer, totalChars, totalCorrChars, maxTime) {
    setWord('');
    setChrIndex(0);
    setTime(maxTime);
    setMstk(0);
    setWPM(0);
    setCPM(0);
    setAcc(0);
    setspScore(0);
    setMisPenal(0);
    clearTimeout(timer.current);
  
    totalChars.current = 0;
    totalCorrChars.current = 0;
    timer.current = undefined;
    const input = document.querySelector('input[type="text"]');
    if (input) input.focus();
  }
  